import "./qb-auth";
import "./qb-webhooks";

angular.module( 'providers.quickbase', [
  'ais.qb-webhooks',
  'ais.qb-auth',
]);